<template>
    <div>
        <h1 class="text-2xl mt-5 font-serif text-[#2A4493] mb-8">
            LES EVENEMENTS A VENIR A NE PAS RATER
        </h1>

        <div class="flex flex-row flex-wrap gap-4 ">
            <XEventCard
                v-for="item in upcomingEvent" v-if="upcomingEvent.length > 0"
                :category="item.category.name" @action="navigator(item)"
                :source="item.image ? asset('storage/' + item.image) : asset('images/event.jpg')"
                :title="item.title"
                :description="purifyHTML(item.description,'textOnly')" :date="item.start_date"
                :end-date="item.end_date"
            />
        </div>
    </div>
</template>

<script setup>

import XEventCard from "@/vue/Public/XEventCard.vue";
import purifyHTML, {asset, route} from "@/helper.js";

const props = defineProps({
    upcomingEvent: {
        type: [Array, Object, null],
        default: []
    },
})

const navigator = (item) => {
    window.location.href = route('events.detail', {event: item.id});
}
</script>
